module.exports = __webpack_public_path__ + "static/placeholder-33eefd9676c3872dcebfcb0c6968d816.png";